import http from "../utils/http";

export const getTenantUsage = async (): Promise<Response> => {
  return await http.get("/api/usages");
};
